
'use strict';

/* Storefront copy — populated by snippets/theme-globals.liquid from the locale files. */
const STR = (group, key) => (window.dostStrings?.[group]?.[key]) ?? '';

const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

function trapFocus(el) {
  const focusable = $$('a,button,input,textarea,select,[tabindex]:not([tabindex="-1"])', el).filter(e => !e.disabled);
  const first = focusable[0], last = focusable[focusable.length - 1];
  el.addEventListener('keydown', function handler(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  });
  first && first.focus();
}

function lockScroll()   { document.body.style.overflow = 'hidden'; }
function unlockScroll() { document.body.style.overflow = ''; }

/* Swipe-down-to-close for bottom sheets */
window.DostSwipeToClose = function (panel, onClose, opts) {
  if (!panel || typeof onClose !== 'function') return;
  opts = opts || {};
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const scrollEl = opts.scrollEl || panel;
  const threshold = opts.threshold || 90;
  const minVelocity = opts.velocity || 0.5;

  let startY = 0, startX = 0, startT = 0;
  let dragging = false, dy = 0;
  let prevTransition = '';

  function getHandleEls() {
    if (!opts.handle) return null;
    if (typeof opts.handle === 'string') {
      return Array.from(panel.querySelectorAll(opts.handle));
    }
    if (Array.isArray(opts.handle)) return opts.handle.filter(Boolean);
    return [opts.handle];
  }

  function onStart(e) {
    if (!isMobile()) return;
    if (!e.touches || e.touches.length !== 1) return;
    const t = e.touches[0];
    if (opts.handle) {
      const handles = getHandleEls();
      if (!handles || !handles.length) return;
      const inside = handles.some(h => h && h.contains(e.target));
      if (!inside) return;
    } else {
      if (scrollEl.scrollTop > 0) return;
    }
    startY = t.clientY;
    startX = t.clientX;
    startT = performance.now();
    dy = 0;
    dragging = true;
    prevTransition = panel.style.transition;
  }

  function onMove(e) {
    if (!dragging || !e.touches || e.touches.length !== 1) return;
    const t = e.touches[0];
    const deltaY = t.clientY - startY;
    const deltaX = t.clientX - startX;
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
      dragging = false;
      panel.style.transition = prevTransition;
      panel.style.transform = '';
      return;
    }
    if (deltaY <= 0) {
      panel.style.transform = '';
      dy = 0;
      return;
    }
    dy = deltaY;
    panel.style.transition = 'none';
    panel.style.transform = 'translateY(' + deltaY + 'px)';
    if (e.cancelable) e.preventDefault();
  }

  function onEnd() {
    if (!dragging) return;
    dragging = false;
    const dt = Math.max(1, performance.now() - startT);
    const velocity = dy / dt;
    panel.style.transition = prevTransition;
    panel.style.transform = '';
    if (dy > threshold || velocity > minVelocity) {
      onClose();
    }
  }

  panel.addEventListener('touchstart', onStart, { passive: true });
  panel.addEventListener('touchmove', onMove, { passive: false });
  panel.addEventListener('touchend', onEnd, { passive: true });
  panel.addEventListener('touchcancel', onEnd, { passive: true });
};

/* Product card image carousel */
window.DostInitProductCards = function(root) {
  var scope = root || document;
  scope.querySelectorAll('.pc[data-product-handle]:not([data-pc-init])').forEach(function(card) {
    card.setAttribute('data-pc-init', '1');

    var slides  = card.querySelectorAll('[data-pc-slide]');
    var dots    = card.querySelectorAll('[data-pc-dot]');
    var prevBtn = card.querySelector('[data-pc-prev]');
    var nextBtn = card.querySelector('[data-pc-next]');
    var current = 0;

    if (slides.length < 2) return;

    function goTo(idx) {
      slides[current].classList.remove('pc__slide--active');
      if (dots[current]) dots[current].classList.remove('pc__dot--active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('pc__slide--active');
      if (dots[current]) dots[current].classList.add('pc__dot--active');
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); goTo(current - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); goTo(current + 1);
    });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        goTo(parseInt(this.dataset.pcDot));
      });
    });

    var media = card.querySelector('[data-pc-media]');
    if (!media) return;
    var tx = 0, ty = 0, axis = null;
    media.addEventListener('touchstart', function(e) {
      tx = e.changedTouches[0].clientX;
      ty = e.changedTouches[0].clientY;
      axis = null;
    }, { passive: true });
    media.addEventListener('touchmove', function(e) {
      if (!axis) {
        var dx = Math.abs(e.changedTouches[0].clientX - tx);
        var dy = Math.abs(e.changedTouches[0].clientY - ty);
        if (dx + dy < 8) return;
        axis = dx > dy ? 'x' : 'y';
        if (axis === 'x') e.stopPropagation();
      }
      if (axis === 'x' && e.cancelable) e.preventDefault();
    }, { passive: false });
    media.addEventListener('touchend', function(e) {
      var dx = tx - e.changedTouches[0].clientX;
      if (axis === 'x' && Math.abs(dx) > 40) goTo(dx > 0 ? current + 1 : current - 1);
    }, { passive: true });
  });
};
document.addEventListener('DOMContentLoaded', function() { window.DostInitProductCards(document); });

// Fade in images once their file has loaded.
window.DostInitImageFade = function(root) {
  (root || document).querySelectorAll('.pc__img, .pdp__main-image').forEach(function(img) {
    if (img.classList.contains('is-loaded')) return;
    if (img.complete && img.naturalWidth) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function() { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function() { img.classList.add('is-loaded'); }, { once: true });
    }
  });
};
document.addEventListener('DOMContentLoaded', function() { window.DostInitImageFade(document); });
document.addEventListener('shopify:section:load', function(e) { window.DostInitImageFade(e.target); });

// Watch for async-injected images (recently viewed, recommendations, search results, quick view).
if (typeof MutationObserver !== 'undefined') {
  var dostImgFadeObserver = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.pc__img, .pdp__main-image')) {
          window.DostInitImageFade(node.parentNode || document);
        } else if (node.querySelector && node.querySelector('.pc__img, .pdp__main-image')) {
          window.DostInitImageFade(node);
        }
      }
    }
  });
  document.addEventListener('DOMContentLoaded', function() {
    dostImgFadeObserver.observe(document.body, { childList: true, subtree: true });
  });
}

window.addEventListener('pageshow', unlockScroll);
window.addEventListener('popstate', unlockScroll);
document.addEventListener('shopify:section:load', unlockScroll);

function formatMoney(cents, currency = window.Shopify?.currency?.active || 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
}

class CartAPI {
  static async get() {
    const r = await fetch('/cart.js');
    return r.json();
  }
  static async add(items) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    return r.json();
  }
  static async change(id, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });
    return r.json();
  }
  static async update(updates) {
    const r = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    return r.json();
  }
}

const bus = {
  listeners: {},
  on(event, fn)   { (this.listeners[event] = this.listeners[event] || []).push(fn); },
  off(event, fn)  { this.listeners[event] = (this.listeners[event] || []).filter(f => f !== fn); },
  emit(event, data) { (this.listeners[event] || []).forEach(fn => fn(data)); },
};

window.DostShowStockToast = function (msg) {
  let toast = document.getElementById('dost-stock-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'dost-stock-toast';
    toast.className = 'dost-stock-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;

  const openDrawer = document.querySelector('.cart-drawer.cart-drawer--open');
  const checkoutBtn = openDrawer && openDrawer.querySelector('[data-checkout-btn]');
  if (checkoutBtn) {
    const rect = checkoutBtn.getBoundingClientRect();
    const offsetBottom = Math.max(28, window.innerHeight - rect.top + 8);
    toast.style.bottom = offsetBottom + 'px';
  } else {
    toast.style.bottom = '';
  }

  toast.classList.add('dost-stock-toast--visible');
  clearTimeout(window._dostStockToastTimer);
  window._dostStockToastTimer = setTimeout(function () {
    toast.classList.remove('dost-stock-toast--visible');
  }, 2500);
};

class CartDrawer {
  constructor() {
    this.drawer = $('#cart-drawer');
    if (!this.drawer) return;

    this.panel    = $('.cart-drawer__panel', this.drawer);
    this.body     = $('.cart-drawer__body',  this.drawer);
    this.countEls = $$('[data-cart-count]');

    window.DostSwipeToClose(this.panel, () => this.close(), {
      handle: '.cart-drawer__handle, .cart-drawer__header'
    });

    this._compareCache = {};
    this._inventoryCache = {};
    $$('[data-cart-item]', this.drawer).forEach(el => {
      const vid = el.dataset.variantId;
      const cmp = parseInt(el.dataset.comparePrice || '0', 10);
      if (vid && cmp > 0) this._compareCache[vid] = cmp;

      if (vid) {
        this._inventoryCache[vid] = {
          qty:     parseInt(el.dataset.inventory     || '-1',    10),
          policy:  el.dataset.inventoryPolicy        || 'deny',
          managed: el.dataset.inventoryManaged       === 'true',
        };
      }
    });

    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-cart-open]');
      if (!trigger) return;
      if (window.dostConfig && window.dostConfig.cartType === 'page') {
        e.preventDefault();
        var cartUrl = (window.dostConfig.routes && window.dostConfig.routes.cart_url) || '/cart';
        window.location.href = cartUrl;
        return;
      }
      e.preventDefault();
      this.open();
    });

    this.drawer.addEventListener('click', e => {
      if (e.target.closest('[data-cart-close]')) this.close();
    });
    document.addEventListener('keydown', e => e.key === 'Escape' && this.close());

    this.drawer.addEventListener('click', async e => {
      const minusBtn  = e.target.closest('[data-qty-minus]');
      const plusBtn   = e.target.closest('[data-qty-plus]');
      const removeBtn = e.target.closest('[data-remove-item]');
      if (!minusBtn && !plusBtn && !removeBtn) return;
      e.stopPropagation();

      const btn = minusBtn || plusBtn || removeBtn;
      if (btn.disabled) return;
      btn.disabled = true;

      try {
        let cart;
        if (minusBtn || plusBtn) {
          const input      = btn.closest('.qty-stepper')?.querySelector('[data-qty-input]');
          const currentQty = parseInt(input?.value || '1', 10);
          const newQty     = minusBtn ? Math.max(0, currentQty - 1) : currentQty + 1;

          if (plusBtn) {
            const li  = btn.closest('[data-cart-item]');
            const vid = li?.dataset.variantId;
            const inv = vid ? this._inventoryCache[vid] : null;
            if (inv && inv.managed && inv.policy === 'deny' && newQty > inv.qty) {
              this.showStockToast(`Only ${inv.qty} left in stock`);
              btn.disabled = false;
              return;
            }
          }

          if (input) input.value = newQty;
          cart = await CartAPI.change(btn.dataset.key, newQty);
        } else {
          cart = await CartAPI.change(btn.dataset.key, 0);
        }

        // Optimistic update for items/count from change.js response,
        // then refresh from /cart.js so discount_applications reflect
        // server-side recalculation (change.js response can omit them).
        if (cart && Array.isArray(cart.items)) {
          this.updateCount(cart.item_count);
          this.updateItems(cart);
        }
        bus.emit('cart:updated');
      } catch (_) {
        bus.emit('cart:updated');
      } finally {
        btn.disabled = false;
      }
    });

    this.drawer.addEventListener('change', async e => {
      if (!e.target.matches('[data-qty-input]')) return;
      const input = e.target;
      const qty   = Math.max(0, parseInt(input.value) || 0);
      try {
        const cart = await CartAPI.change(input.dataset.key, qty);
        if (cart && Array.isArray(cart.items)) {
          this.updateCount(cart.item_count);
          this.updateItems(cart);
        }
        bus.emit('cart:updated');
      } catch (_) {
        bus.emit('cart:updated');
      }
    });

    bus.on('cart:updated', () => this.refresh());
    bus.on('cart:open',    () => this.open());
    document.addEventListener('dost:open-cart', () => this.open());
    document.addEventListener('cart:updated', () => bus.emit('cart:updated'));
  }

  showStockToast(msg) {
    window.DostShowStockToast(msg);
  }

  open() {
    this.drawer.classList.add('cart-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    trapFocus(this.panel);
  }

  close() {
    this.drawer.classList.remove('cart-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  async refresh() {
    const cart = await CartAPI.get();
    this.updateCount(cart.item_count);
    this.updateItems(cart);
    this.updateFooter(cart);
  }

  updateCount(count) {
    this.countEls.forEach(el => {
      if (el.classList.contains('cart-drawer__count')) {
        el.textContent = count > 0 ? `(${count})` : '';
      } else {
        el.textContent = count > 0 ? String(count) : '';
        el.hidden = count === 0;
      }
    });
  }

  updateItems(cart) {
    const emptyEl  = $('[data-cart-empty]',  this.body);
    const itemsEl  = $('[data-cart-items]',  this.body);
    const extrasEl = $('[data-cart-extras]', this.body);
    const footerEl = $('.cart-drawer__footer', this.drawer);

    const isEmpty = cart.items.length === 0;

    if (emptyEl)  emptyEl.hidden  = !isEmpty;
    if (itemsEl)  itemsEl.hidden  =  isEmpty;
    if (extrasEl) extrasEl.hidden =  isEmpty;
    if (footerEl) footerEl.hidden =  isEmpty;

    if (isEmpty || !itemsEl) return;

    cart.items.forEach(item => {
      const vid = String(item.variant_id);
      const cmp = parseInt(item.compare_at_price || '0', 10);
      if (vid && cmp > 0) this._compareCache[vid] = cmp;
    });

    itemsEl.innerHTML = cart.items.map(item => this.itemHTML(item)).join('');
  }

  itemHTML(item) {
    const esc = s => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

    const compareAtPrice = parseInt(item.compare_at_price || this._compareCache[String(item.variant_id)] || '0', 10);
    const onSale = compareAtPrice > 0 && compareAtPrice > item.price;
    const discounted = !onSale && item.original_line_price && item.original_line_price !== item.final_line_price;

    const unitPriceHTML = onSale
      ? `<s class="cart-item__compare-price">${formatMoney(compareAtPrice)}</s>
         <span class="cart-item__unit-price cart-item__unit-price--sale">${formatMoney(item.price)}</span>`
      : `<span class="cart-item__unit-price">${formatMoney(item.price)}</span>`;

    let lineTotalHTML = '';
    if (onSale) {
      lineTotalHTML = `<s class="cart-item__compare-total">${formatMoney(compareAtPrice * item.quantity)}</s>
                       <span class="cart-item__final-price cart-item__final-price--sale">${formatMoney(item.final_line_price)}</span>`;
    } else if (discounted) {
      lineTotalHTML = `<s class="cart-item__compare-total">${formatMoney(item.original_line_price)}</s>
                       <span class="cart-item__final-price cart-item__final-price--sale">${formatMoney(item.final_line_price)}</span>`;
    } else {
      lineTotalHTML = `<span class="cart-item__final-price">${formatMoney(item.final_line_price)}</span>`;
    }

    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-item__variant">${esc(item.variant_title)}</p>` : '';

    let unitMeasureHTML = '';
    const um = item.unit_price_measurement;
    if (um && item.unit_price != null) {
      const refVal = (um.reference_value != null && um.reference_value !== 1) ? um.reference_value : '';
      unitMeasureHTML =
        `<p class="cart-item__unit-measure">` +
          `<span class="visually-hidden">${esc(STR('cart', 'unitPrice'))}</span> ` +
          `${formatMoney(item.unit_price)} <span aria-hidden="true">/</span> ` +
          `${refVal}${esc(um.reference_unit || '')}` +
        `</p>`;
    }

    const img = item.featured_image?.url || item.image;
    const imgTag = img
      ? `<a href="${esc(item.url)}" tabindex="-1" aria-hidden="true">
           <img src="${esc(img)}" alt="${esc(item.product_title)}" loading="lazy" class="cart-item__img">
         </a>`
      : '';

    const ratio = window.dostConfig?.cardImageRatio || 'original';
    const ratioMap = { '3-4': 'aspect-ratio:3/4;', '1-1': 'aspect-ratio:1/1;', '4-5': 'aspect-ratio:4/5;', '4-3': 'aspect-ratio:4/3;' };
    const mediaStyle = ratioMap[ratio] ? `style="${ratioMap[ratio]}"` : '';
    const mediaClass = `cart-item__media${ratio === 'original' || !ratioMap[ratio] ? ' cart-item__media--original' : ''}`;

    return `
      <li class="cart-item" data-cart-item data-item-key="${esc(item.key)}" data-variant-id="${esc(item.variant_id)}" data-compare-price="${compareAtPrice}">
        <div class="${mediaClass}" ${mediaStyle}>${imgTag}</div>
        <div class="cart-item__details">
          <a href="${esc(item.url)}" class="cart-item__title">${esc(item.product_title)}</a>
          ${variant}
          <div class="cart-item__unit-price-row">${unitPriceHTML}</div>
          ${unitMeasureHTML}
          <div class="cart-item__meta">
            <div class="qty-stepper" role="group" aria-label="${esc(STR('cart', 'quantity'))}">
              <button class="qty-stepper__btn btn-reset" type="button" aria-label="${esc(STR('cart', 'decrease'))}" data-key="${esc(item.key)}" data-qty-minus>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
              <input class="qty-stepper__input" type="number" inputmode="numeric" min="0" max="999" value="${item.quantity}" aria-label="${esc(STR('cart', 'quantity'))}" data-key="${esc(item.key)}" data-qty-input>
              <button class="qty-stepper__btn btn-reset" type="button" aria-label="${esc(STR('cart', 'increase'))}" data-key="${esc(item.key)}" data-qty-plus>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
            </div>
            <div class="cart-item__line-total" data-item-price>${lineTotalHTML}</div>
          </div>
          <button class="cart-item__remove" type="button" data-key="${esc(item.key)}" data-remove-item aria-label="${esc(STR('cart', 'remove'))}">${esc(STR('cart', 'remove'))}</button>
        </div>
      </li>`;
  }

  updateFooter(cart) {
    const subtotalWrap = $('[data-cart-subtotal-wrap]', this.drawer);
    if (subtotalWrap) {
      if (cart.total_discount > 0) {
        subtotalWrap.innerHTML =
          `<s class="cart-drawer__subtotal-original" data-cart-subtotal>${formatMoney(cart.original_total_price)}</s>` +
          `<span class="cart-drawer__subtotal-price cart-drawer__subtotal-price--sale" data-cart-total>${formatMoney(cart.total_price)}</span>`;
      } else {
        subtotalWrap.innerHTML =
          `<span class="cart-drawer__subtotal-price" data-cart-total>${formatMoney(cart.total_price)}</span>`;
      }
    }

    const discountAppliedEl = $('[data-cart-discount-applied]', this.drawer);
    if (discountAppliedEl) {
      const rawApps = cart.cart_level_discount_applications
        || cart.discount_applications
        || [];
      const apps = rawApps.filter(d =>
        d && (d.target_selection === 'all' || d.target_type !== 'line_item')
      );
      if (apps.length > 0) {
        const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        const tags = apps.map(d => {
          const label = d.title || d.code || d.key || '';
          if (!label) return '';
          let rate = '';
          if (d.value_type === 'percentage' && d.value != null) {
            rate = ` <span class="cart-drawer__discount-rate">· ${Math.round(parseFloat(d.value))}%</span>`;
          } else if (typeof d.total_allocated_amount === 'number' && d.total_allocated_amount > 0) {
            rate = ` <span class="cart-drawer__discount-rate">· −${formatMoney(d.total_allocated_amount)}</span>`;
          }
          return `<span class="cart-drawer__discount-tag">${esc(label)}${rate}</span>`;
        }).filter(Boolean).join('');
        if (tags) {
          discountAppliedEl.innerHTML = tags;
          discountAppliedEl.hidden = false;
        } else {
          discountAppliedEl.innerHTML = '';
          discountAppliedEl.hidden = true;
        }
      } else {
        discountAppliedEl.innerHTML = '';
        discountAppliedEl.hidden = true;
      }
    }

    const form = $('.cart-drawer__checkout-form', this.drawer);
    if (form) {
      const saved = sessionStorage.getItem('dost-discount');
      let hidden = form.querySelector('input[name="discount"]');
      if (saved) {
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'discount';
          form.appendChild(hidden);
        }
        hidden.value = saved;
      } else if (hidden) {
        hidden.remove();
      }
    }

    const shippingEl = $('[data-free-shipping]', this.drawer);
    if (shippingEl) {
      const threshold = window.dostConfig?.freeShippingThreshold || 0;
      if (threshold > 0 && threshold < 9999900) {
        const remaining = threshold - cart.total_price;
        const pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
        if (remaining > 0) {
          shippingEl.innerHTML =
            `<p class="cart-drawer__fs-label">${STR('cart', 'freeShippingProgressHtml').replace('__AMOUNT__', formatMoney(remaining))}</p>
             <div class="cart-drawer__fs-track" role="progressbar">
               <div class="cart-drawer__fs-fill" style="width:${pct}%"></div>
             </div>`;
        } else {
          shippingEl.innerHTML = `<p class="cart-drawer__fs-achieved">${STR('cart', 'freeShippingAchieved')}</p>`;
        }
      }
    }
  }
}

class SearchOverlay {
  constructor() {
    this.overlay    = $('#search-overlay');
    this.backdrop   = $('.search-overlay-backdrop');
    this.input      = $('#search-input');
    this.clearBtn   = $('[data-search-clear]');
    this.emptyL     = $('[data-search-empty-left]');
    this.emptyR     = $('[data-search-empty-right]');
    this.suggestions = $('[data-search-suggestions]');
    this.results    = $('#search-results');
    this.footer     = $('[data-search-footer]');

    if (!this.overlay) return;

    // Read server-side config
    try {
      this.cfg = JSON.parse($('#search-config')?.textContent || '{}');
    } catch { this.cfg = {}; }

    // Open
    document.addEventListener('click', e => {
      if (e.target.closest('[data-search-open]')) { e.stopPropagation(); this.open(); }
    });

    document.addEventListener('click', e => {
      if (e.target.closest('[data-search-close]')) this.close();
    });

    document.addEventListener('click', e => {
      if (
        this.overlay.classList.contains('search-overlay--visible') &&
        !this.overlay.contains(e.target) &&
        !e.target.closest('[data-search-open]')
      ) this.close();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); this.open(); }
    });

    this.input?.addEventListener('input', this.debounce(() => {
      const q = this.input.value.trim();
      this.setClear(!!q);
      if (q.length >= 1) this.search(q);
      else this.showEmpty();
    }, 280));

    this.input?.addEventListener('keydown', e => {
      if (e.key !== 'Enter') return;
      const q = this.input.value.trim();
      if (!q) return;
      e.preventDefault();
      const root = (window.dostConfig && window.dostConfig.routes && window.dostConfig.routes.root_url) || '/';
      const base = root.replace(/\/$/, '') + '/search';
      window.location = base + '?q=' + encodeURIComponent(q);
    });

    this.clearBtn?.addEventListener('click', () => {
      this.input.value = '';
      this.setClear(false);
      this.showEmpty();
      this.input.focus();
    });

    this.overlay.addEventListener('click', e => {
      const btn = e.target.closest('[data-trending-term]');
      if (!btn) return;
      const term = btn.dataset.trendingTerm;
      this.input.value = term;
      this.setClear(true);
      this.search(term);
    });
  }

  setClear(visible) {
    if (!this.clearBtn) return;
    this.clearBtn.classList.toggle('so-visible', visible);
  }

  open() {
    const header = document.querySelector('.header') || document.getElementById('site-header');
    if (header) {
      document.documentElement.style.setProperty('--search-top', header.getBoundingClientRect().bottom + 'px');
    }
    this.overlay.classList.add('search-overlay--visible');
    this.overlay.setAttribute('aria-hidden', 'false');
    if (this.backdrop) this.backdrop.classList.add('is-visible');
    this.showEmpty();
    setTimeout(() => this.input?.focus(), 50);
  }

  close() {
    this.overlay.classList.remove('search-overlay--visible');
    this.overlay.setAttribute('aria-hidden', 'true');
    if (this.backdrop) this.backdrop.classList.remove('is-visible');
    if (this.input) this.input.value = '';
    this.setClear(false);
    this.showEmpty();
  }

  showEmpty() {
    if (this.emptyL)     this.emptyL.hidden     = false;
    if (this.emptyR)     this.emptyR.hidden     = false;
    if (this.suggestions) this.suggestions.hidden = true;
    if (this.results)    this.results.hidden    = true;
    if (this.footer)     this.footer.hidden     = true;
    if (this.suggestions) this.suggestions.innerHTML = '';
    if (this.results)    this.results.innerHTML    = '';
  }

  showResults() {
    if (this.emptyL)     this.emptyL.hidden     = true;
    if (this.emptyR)     this.emptyR.hidden     = true;
    if (this.suggestions) this.suggestions.hidden = false;
    if (this.results)    this.results.hidden    = false;
  }

  async search(query) {
    const cfg = this.cfg;
    const types = [];
    if (cfg.includeProducts)    types.push('product');
    if (cfg.includeCollections) types.push('collection');
    if (cfg.includeArticles)    types.push('article');
    if (cfg.includePages)       types.push('page');
    if (!types.length) types.push('product');

    const q       = encodeURIComponent(query);
    const typeStr = types.join(',');
    // resources[limit] applies to EVERY type. Use the max of the configured caps
    // so each section can render fully; we slice per-section in renderResults.
    const productLimit = cfg.productLimit || 4;
    const limit  = Math.max(productLimit, 6, 10);
    const policy = cfg.unavailableProducts || 'last';
    const url = `/search/suggest.json?q=${q}&resources[type]=${typeStr}&resources[limit]=${limit}&resources[options][unavailable_products]=${policy}`;

    try {
      const r    = await fetch(url);
      const data = await r.json();
      this.renderResults(data.resources?.results || {}, query);
    } catch {
      this.renderNoResults(query);
    }
  }

  renderResults(res, query) {
    const cfg         = this.cfg;
    const products    = res.products    || [];
    const collections = res.collections || [];
    const articles    = res.articles    || [];
    const pages       = res.pages       || [];

    if (!products.length && !collections.length && !articles.length && !pages.length) {
      this.renderNoResults(query);
      return;
    }

    this.showResults();

    const suggestionItems = [
      `<li><a href="/search?q=${encodeURIComponent(query)}" class="search-overlay__suggestion-item search-overlay__suggestion-item--active">${this.esc(query)}</a></li>`,
      ...products.slice(0, 5).map(p =>
        `<li><a href="${p.url}" class="search-overlay__suggestion-item">${this.highlight(p.title, query)}</a></li>`
      )
    ].join('');

    this.suggestions.innerHTML = `
      <p class="search-overlay__section-label">${this.esc(STR('search', 'suggestions'))}</p>
      <ul class="search-overlay__suggestion-list">${suggestionItems}</ul>`;

    let html = '';

    if (products.length) {
      const cards = products.slice(0, cfg.productLimit || 4).map(p => this.productCard(p)).join('');
      html += `<div class="search-overlay__result-section">
        <p class="search-overlay__section-label">${this.esc(STR('search', 'products'))}</p>
        <div class="search-overlay__product-grid">${cards}</div>
      </div>`;
    }

    if (collections.length) {
      const items = collections.slice(0, 6).map(c =>
        `<li><a href="${c.url}" class="search-overlay__col-link">${this.highlight(c.title, query)}</a></li>`
      ).join('');
      html += `<div class="search-overlay__result-section">
        <p class="search-overlay__section-label">${this.esc(STR('search', 'collections'))}</p>
        <ul class="search-overlay__col-list">${items}</ul>
      </div>`;
    }

    if (articles.length) {
      const items = articles.slice(0, 3).map(a => `
        <li><a href="${a.url}" class="search-overlay__article-item">
          <span class="search-overlay__article-title">${this.esc(a.title)}</span>
          <span class="search-overlay__article-date">${a.published_at ? this.fmtDate(a.published_at) : ''}</span>
        </a></li>`).join('');
      html += `<div class="search-overlay__result-section">
        <p class="search-overlay__section-label">${this.esc(STR('search', 'articles'))}</p>
        <ul class="search-overlay__article-list">${items}</ul>
      </div>`;
    }

    if (pages.length) {
      const pItems = pages.slice(0, 3).map(p =>
        `<li><a href="${p.url}" class="search-overlay__suggestion-item">${this.esc(p.title)}</a></li>`
      ).join('');
      html += `<div class="search-overlay__result-section">
        <p class="search-overlay__section-label">${this.esc(STR('search', 'pages'))}</p>
        <ul class="search-overlay__suggestion-list">${pItems}</ul>
      </div>`;
    }

    this.results.innerHTML = html;
    this.footer.hidden = false;
    const va = this.footer.querySelector('[data-search-view-all]');
    if (va) va.href = `/search?q=${encodeURIComponent(query)}`;
  }

  renderNoResults(query) {
    this.showResults();
    this.suggestions.innerHTML = `<p class="search-overlay__section-label">${this.esc(STR('search', 'suggestions'))}</p>`;
    this.results.innerHTML = `
      <div class="search-overlay__no-results">
        <p class="search-overlay__no-results-heading">${STR('search', 'noResultsHeading').replace('__TERMS__', this.esc(query))}</p>
        <p class="search-overlay__no-results-sub">${STR('search', 'noResultsSubHtml')}</p>
      </div>`;
    if (this.footer) this.footer.hidden = true;
  }

  productCard(p) {
    const cfg = this.cfg;
    const ratio = window.dostConfig?.cardImageRatio || 'original';
    const ratioMap = { '3-4': 'aspect-ratio:3/4;', '1-1': 'aspect-ratio:1/1;', '4-5': 'aspect-ratio:4/5;', '4-3': 'aspect-ratio:4/3;' };
    const mediaStyle = ratioMap[ratio] ? ` style="${ratioMap[ratio]}"` : '';
    const mediaClass = `search-result__media${ratio === 'original' || !ratioMap[ratio] ? ' search-result__media--original' : ''}`;
    const img = p.featured_image?.url
      ? `<img src="${p.featured_image.url}" alt="${this.esc(p.title)}" loading="lazy" class="search-result__img">`
      : '<div class="search-result__img-placeholder"></div>';
    const vendor = cfg.showVendor && p.vendor ? `<p class="search-result__vendor">${this.esc(p.vendor)}</p>` : '';
    let price = '';
    if (cfg.showPrice && p.price) {
      const pNum = parseFloat(p.price_min ?? p.price);
      const cNum = parseFloat(p.compare_at_price_min ?? p.compare_at_price);
      const onSale = isFinite(pNum) && isFinite(cNum) && cNum > pNum;
      price = onSale
        ? `<p class="search-result__price search-result__price--sale">
             <s class="search-result__price-was">${this.formatPrice(p.compare_at_price_min ?? p.compare_at_price)}</s>
             <span class="search-result__price-now">${this.formatPrice(p.price)}</span>
           </p>`
        : `<p class="search-result__price">${this.formatPrice(p.price)}</p>`;
    }
    const badges = cfg.showBadges ? this.productBadges(p) : '';
    return `<a href="${p.url}" class="search-result__product">
      <div class="${mediaClass}"${mediaStyle}>${img}${badges}</div>
      ${vendor}
      <p class="search-result__title">${this.esc(p.title)}</p>
      ${price}
    </a>`;
  }

  productBadges(p) {
    const b = this.cfg.badges || {};
    const items = [];
    const tags = (p.tags || []).map(t => String(t).toLowerCase().trim());
    const hasTag = (t) => t && tags.includes(String(t).toLowerCase().trim());
    const isPreorder = hasTag('pre-order');
    const isNew      = hasTag(b.new?.tag || 'new');
    const price   = parseFloat(p.price_min ?? p.price);
    const compare = parseFloat(p.compare_at_price_min ?? p.compare_at_price);
    const isSale = isFinite(price) && isFinite(compare) && compare > price;
    const isSold = p.available === false;

    const mk = (bg, color, label) =>
      `<span class="search-result__badge" style="background:${bg};color:${color};">${this.esc(label)}</span>`;

    if (isSold && !isPreorder) {
      items.push(mk(b.sold?.color || '#D9D9D9', b.sold?.textColor || '#3A3A3A', b.sold?.label || 'Sold out'));
    } else {
      if (b.preorder?.enabled && isPreorder) {
        items.push(mk(b.preorder.color, b.preorder.textColor || '#fff', b.preorder.label));
      }
      if (isSale) {
        items.push(mk(b.sale?.color || '#C8A96E', b.sale?.textColor || '#fff', b.sale?.label || 'Sale'));
      } else if (isNew && b.new?.label) {
        items.push(mk(b.new.color || '#0D0D0D', b.new.textColor || '#fff', b.new.label));
      }
    }

    ['custom1', 'custom2'].forEach(key => {
      const c = b[key];
      if (c && c.label && c.tag && hasTag(c.tag)) {
        items.push(mk(c.color || '#0D0D0D', c.textColor || '#fff', c.label));
      }
    });

    return items.length ? `<div class="search-result__badges">${items.join('')}</div>` : '';
  }

  highlight(text, query) {
    const esc = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return this.esc(text).replace(new RegExp(`(${esc})`, 'gi'), '<strong>$1</strong>');
  }

  esc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  formatPrice(value) {
    if (value == null || value === '') return '';
    const str = String(value).trim();
    const numMatch = str.match(/[\d.,\s']+/);
    if (!numMatch) return str;
    let raw = numMatch[0].replace(/\s/g, '');
    const lastDot = raw.lastIndexOf('.');
    const lastComma = raw.lastIndexOf(',');
    if (lastComma > lastDot) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else {
      raw = raw.replace(/,/g, '');
    }
    const n = parseFloat(raw);
    if (!isFinite(n)) return str;
    const fmt = window.dostConfig?.moneyFormat || '${{amount}}';
    const fmtNum = (num, decimals, thousandsSep, decimalSep) => {
      const parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      return parts.join(decimalSep);
    };
    return fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', fmtNum(n, 0, '.', ','))
      .replace('{{amount_no_decimals_with_space_separator}}', fmtNum(n, 0, ' ', ','))
      .replace('{{amount_with_comma_separator}}',             fmtNum(n, 2, '.', ','))
      .replace('{{amount_with_space_separator}}',             fmtNum(n, 2, ' ', ','))
      .replace('{{amount_with_apostrophe_separator}}',        fmtNum(n, 2, "'", '.'))
      .replace('{{amount_no_decimals}}',                      fmtNum(n, 0, ',', '.'))
      .replace('{{amount}}',                                  fmtNum(n, 2, ',', '.'));
  }

  fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(window.dostConfig?.locale || 'en', {
        month: 'short', day: 'numeric', year: 'numeric'
      });
    } catch { return ''; }
  }

  debounce(fn, ms) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }
}

class MegaMenu {
  constructor() {
    this.backdrop = $('.mega-menu__backdrop');
    this._timer   = null;

    $$('[data-mega-trigger]').forEach(trigger => {
      const target = $(`#${trigger.dataset.megaTrigger}`);
      if (!target) return;

      const show = () => {
        clearTimeout(this._timer);
        this.show(target);
      };
      const scheduleHide = () => {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.hide(target), 80);
      };

      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('focus',      () => this.show(target));
      target.addEventListener('mouseenter',  () => clearTimeout(this._timer));
      target.addEventListener('mouseleave',  scheduleHide);
      trigger.addEventListener('mouseleave', scheduleHide);
    });

    if (!MegaMenu._docBound) {
      MegaMenu._docBound = true;
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') $$('.mega-menu--visible').forEach(m => m.classList.remove('mega-menu--visible'));
      });
      document.addEventListener('click', e => {
        if (!e.target.closest('[data-mega-trigger]') &&
            !e.target.closest('.mega-menu') &&
            !e.target.closest('.mega-menu-panel')) {
          $$('.mega-menu--visible').forEach(m => m.classList.remove('mega-menu--visible'));
          $('.mega-menu__backdrop')?.classList.remove('mega-menu__backdrop--visible');
        }
      });
    }
  }

  show(menu) {
    this.hideAll();
    const header = document.querySelector('.header') || document.getElementById('site-header');
    if (header) {
      const bottom = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--search-top', Math.max(bottom, 0) + 'px');
    }
    menu.classList.add('mega-menu--visible');
    this.backdrop?.classList.add('mega-menu__backdrop--visible');
    if (menu.classList.contains('dropdown-panel')) {
      this.clampDropdownToViewport(menu);
    }
  }

  clampDropdownToViewport(panel) {
    // Reset any prior inline overrides so the CSS centering applies first.
    panel.style.left = '';
    panel.style.right = '';
    panel.style.transform = '';
    const margin = 16;
    const rect = panel.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;
    // Drop the translateX(-50%) centering when we anchor by left/right, but keep
    // the translateY(0) so the open-state slide animation still applies.
    if (rect.left < margin) {
      const parentRect = panel.parentElement.getBoundingClientRect();
      panel.style.left = (margin - parentRect.left) + 'px';
      panel.style.right = 'auto';
      panel.style.transform = 'translateY(0)';
    } else if (rect.right > vw - margin) {
      const parentRect = panel.parentElement.getBoundingClientRect();
      panel.style.left = 'auto';
      panel.style.right = (parentRect.right - (vw - margin)) + 'px';
      panel.style.transform = 'translateY(0)';
    }
  }

  hide(menu) {
    menu.classList.remove('mega-menu--visible');
    if (menu.classList.contains('dropdown-panel')) {
      // Reset any inline clamp overrides so the next open starts from the CSS
      // default position + slide-in animation.
      menu.style.left = '';
      menu.style.right = '';
      menu.style.transform = '';
    }
    if (!$('.mega-menu--visible')) this.backdrop?.classList.remove('mega-menu__backdrop--visible');
  }

  hideAll() {
    $$('.mega-menu--visible').forEach(m => m.classList.remove('mega-menu--visible'));
    this.backdrop?.classList.remove('mega-menu__backdrop--visible');
  }
}

class MobileDrawer {
  constructor() {
    this.drawer   = $('#mobile-drawer');
    if (!this.drawer) return;

    this.backdrop = $('.mobile-drawer__backdrop', this.drawer);
    this.panel    = $('.mobile-drawer__panel',    this.drawer);

    $$('[data-mobile-menu-open]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });
    this.backdrop.addEventListener('click', () => this.close());
    $('.mobile-drawer__close', this.drawer)?.addEventListener('click', () => this.close());
    MobileDrawer._instance = this;
    if (!MobileDrawer._docBound) {
      MobileDrawer._docBound = true;
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') MobileDrawer._instance?.close();
      });
    }

    this.drawer.addEventListener('click', e => {
      const toggle = e.target.closest('[data-drawer-toggle]');
      if (toggle && this.drawer.contains(toggle)) {
        this.#handleToggle(toggle);
        return;
      }

      const link = e.target.closest('a[href]');
      if (link) this.close();
    });
  }

  open() {
    this.drawer.classList.add('mobile-drawer--open');
    this.drawer.removeAttribute('aria-hidden');
    lockScroll();
    trapFocus(this.panel);
  }

  close() {
    this.drawer.classList.remove('mobile-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.#collapseAll();
    unlockScroll();
  }

  #handleToggle(toggle) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const nextExpanded = !isExpanded;
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const item = toggle.closest('.mobile-drawer__item');

    toggle.setAttribute('aria-expanded', String(nextExpanded));
    if (item) item.classList.toggle('is-open', nextExpanded);
    if (panel) panel.hidden = !nextExpanded;
  }

  #collapseAll() {
    $$('.mobile-drawer__item.is-open', this.drawer).forEach(item => {
      item.classList.remove('is-open');
    });
    $$('[data-drawer-toggle][aria-expanded="true"]', this.drawer).forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });
    $$('.mobile-drawer__dropdown:not([hidden])', this.drawer).forEach(panel => {
      panel.hidden = true;
    });
  }
}

class StickyHeader {
  constructor() {
    this.header = document.querySelector('.header') || $('#site-header');
    if (!this.header) return;

    this.wrapper = this.header.closest('.header-wrapper');

    this._wasTransparent = this.header.classList.contains('header--transparent');

    const updateSearchTop = () => {
      const bottom = this.header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--search-top', Math.max(bottom, 0) + 'px');
    };

    const updateTransparency = () => {
      if (!this._wasTransparent) return;
      const atTop = window.scrollY <= 0;
      this.header.classList.add('header--transparent');
      if (this.wrapper) {
        this.wrapper.setAttribute('data-transparent', 'true');
        if (atTop) {
          this.wrapper.removeAttribute('data-transparent-scrolled');
        } else {
          this.wrapper.setAttribute('data-transparent-scrolled', 'true');
        }
      }
    };

    const updateScrolled = () => {
      if (!this.wrapper) return;
      if (window.scrollY > 0) {
        this.wrapper.setAttribute('data-scrolled', 'true');
      } else {
        this.wrapper.removeAttribute('data-scrolled');
      }
    };

    const onScroll = () => {
      updateTransparency();
      updateScrolled();
      updateSearchTop();
    };

    StickyHeader._instance = this;
    if (!StickyHeader._docBound) {
      StickyHeader._docBound = true;
      const proxy = () => {
        const inst = StickyHeader._instance;
        if (!inst || !document.contains(inst.header)) return;
        inst._onScroll();
      };
      const proxyResize = () => {
        const inst = StickyHeader._instance;
        if (!inst || !document.contains(inst.header)) return;
        inst._updateSearchTop();
      };
      window.addEventListener('scroll', proxy, { passive: true });
      window.addEventListener('resize', proxyResize, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', proxyResize, { passive: true });
        window.visualViewport.addEventListener('scroll', proxyResize, { passive: true });
      }
    }

    this._onScroll = onScroll;
    this._updateSearchTop = updateSearchTop;
    updateTransparency();
    updateScrolled();
    updateSearchTop();
  }
}

class StickyPDPBar {
  constructor() {
    this.bar    = $('#sticky-pdp-bar');
    this.atcBtn = $('.pdp__atc');
    if (!this.bar || !this.atcBtn) return;

    const obs = new IntersectionObserver(([e]) => {
      this.bar.classList.toggle('sticky-pdp-bar--visible', !e.isIntersecting);
    }, { threshold: 0 });

    obs.observe(this.atcBtn);

    this.bar.querySelector('[data-sticky-atc]')?.addEventListener('click', () => {
      this.atcBtn.click();
    });
  }
}

window.DostInitQuickView = function (root) {
  if (!root) return;

  const gallery = root.querySelector('[data-qv-gallery]');
  if (gallery) {
    const slides = gallery.querySelectorAll('[data-qv-slide]');
    const dots   = gallery.querySelectorAll('[data-qv-dot]');
    const prev   = gallery.querySelector('[data-qv-prev]');
    const next   = gallery.querySelector('[data-qv-next]');

    const pauseSlideMedia = (slide) => {
      if (!slide) return;
      const v = slide.querySelector('video');
      if (v && !v.paused) { try { v.pause(); } catch (e) {} }
      const ifr = slide.querySelector('iframe');
      if (ifr && ifr.src) { ifr.src = ifr.src; }
    };

    const applySlideRatio = (slide) => {
      if (!slide) return;
      const r = parseFloat(slide.getAttribute('data-aspect-ratio'));
      if (r && !isNaN(r) && r > 0) {
        gallery.style.setProperty('--qv-media-ratio', r + ' / 1');
      }
    };

    if (slides[0]) applySlideRatio(slides[0]);

    const warmSlide = (i) => {
      const slide = slides[i];
      if (!slide) return;
      const im = slide.querySelector('img');
      if (!im) return;
      if (im.complete && im.naturalWidth > 0) return;
      im.loading = 'eager';
      if (im.srcset) { im.srcset = im.srcset; }
      else if (im.src) { im.src = im.src; }
    };

    if (slides.length > 1) warmSlide(1);
    if (slides.length > 2) warmSlide(slides.length - 1);

    let curr = 0;
    const go = (i) => {
      if (slides.length < 2) return;
      const nextIdx = (i + slides.length) % slides.length;
      if (nextIdx === curr) return;
      warmSlide(nextIdx);
      pauseSlideMedia(slides[curr]);
      slides[curr].classList.remove('is-active');
      if (dots[curr]) dots[curr].classList.remove('is-active');
      curr = nextIdx;
      slides[curr].classList.add('is-active');
      if (dots[curr]) dots[curr].classList.add('is-active');
      applySlideRatio(slides[curr]);
    };
    gallery._qvGo = go;
    if (prev) {
      prev.addEventListener('click', (e) => { go(curr - 1); e.currentTarget.blur(); });
      prev.addEventListener('pointerenter', () => warmSlide((curr - 1 + slides.length) % slides.length));
    }
    if (next) {
      next.addEventListener('click', (e) => { go(curr + 1); e.currentTarget.blur(); });
      next.addEventListener('pointerenter', () => warmSlide((curr + 1) % slides.length));
    }
    dots.forEach((d, i) => d.addEventListener('click', (e) => { go(i); e.currentTarget.blur(); }));

    if (slides.length > 1) {
      const modal = gallery.closest('.quick-view-modal');
      const onKey = (e) => {
        if (!modal || !modal.classList.contains('quick-view-modal--open')) return;
        const ae = document.activeElement;
        const tag = (ae && ae.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        if (ae && ae.isContentEditable) return;
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          go(curr + 1);
          if (ae && (ae.matches('[data-qv-prev]') || ae.matches('[data-qv-next]') || ae.matches('[data-qv-dot]'))) ae.blur();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          go(curr - 1);
          if (ae && (ae.matches('[data-qv-prev]') || ae.matches('[data-qv-next]') || ae.matches('[data-qv-dot]'))) ae.blur();
        }
      };
      document.addEventListener('keydown', onKey);
    }

    if (slides.length > 1) {
      let tStartX = 0, tStartY = 0, tActive = false, tAxis = null;
      gallery.addEventListener('touchstart', (e) => {
        if (!e.touches || e.touches.length !== 1) return;
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tActive = true;
        tAxis = null;
      }, { passive: true });
      gallery.addEventListener('touchmove', (e) => {
        if (!tActive || !e.touches || !e.touches.length) return;
        if (!tAxis) {
          const adx = Math.abs(e.touches[0].clientX - tStartX);
          const ady = Math.abs(e.touches[0].clientY - tStartY);
          if (adx + ady < 8) return;
          tAxis = adx > ady ? 'x' : 'y';
        }
        if (tAxis === 'x' && e.cancelable) e.preventDefault();
      }, { passive: false });
      gallery.addEventListener('touchend', (e) => {
        if (!tActive) return;
        tActive = false;
        const t = (e.changedTouches && e.changedTouches[0]);
        if (!t) return;
        const dx = t.clientX - tStartX;
        const dy = t.clientY - tStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          go(dx < 0 ? curr + 1 : curr - 1);
        }
      }, { passive: true });
    }
  }

  let variantData = [];
  try {
    const script = root.querySelector('[data-qv-variants]');
    if (script) variantData = JSON.parse(script.textContent);
  } catch (e) {}

  const form = root.querySelector('[data-qv-form]');
  if (!form) return;

  const variantIn  = form.querySelector('[data-variant-id]');
  const atcBtn     = form.querySelector('[data-qv-atc]');
  const atcLabel   = form.querySelector('[data-qv-atc-label]');
  const atcPrice   = form.querySelector('[data-qv-atc-price]');
  const priceBlock = root.querySelector('[data-qv-price]');

  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  const currentOptions = () => {
    const picks = [];
    root.querySelectorAll('[data-qv-option]').forEach(group => {
      const active = group.querySelector('.is-active[data-qv-option-val]');
      if (active) picks.push(active.dataset.val);
    });
    return picks;
  };

  const refreshVariant = () => {
    const picks = currentOptions();
    const match = variantData.find(v =>
      v.options.every((val, i) => val === picks[i])
    );
    if (!match) return;
    if (variantIn) variantIn.value = match.id;

    if (atcBtn) {
      atcBtn.disabled = !match.available;
      if (atcLabel) atcLabel.textContent = match.available ? STR('products', 'addToCart') : STR('products', 'soldOut');
      if (atcPrice) {
        atcPrice.textContent = match.available ? '— ' + money(match.price) : '';
        atcPrice.style.display = match.available ? '' : 'none';
      }
    }

    if (priceBlock) {
      let html = '';
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html = '<span class="qv__price-now qv__price-now--sale">' + money(match.price) + '</span>' +
               '<s class="qv__price-was">' + money(match.compare_at_price) + '</s>';
      } else {
        html = '<span class="qv__price-now">' + money(match.price) + '</span>';
      }
      priceBlock.innerHTML = html;
    }

    const unitEl = root.querySelector('[data-qv-unit-price]');
    if (unitEl) {
      const um = match.unit_price_measurement;
      if (um && match.unit_price != null) {
        const refVal = (um.reference_value != null && um.reference_value !== 1) ? um.reference_value : '';
        unitEl.innerHTML =
          `<span class="visually-hidden">${STR('products', 'unitPrice')}</span>` +
          money(match.unit_price) +
          ' <span aria-hidden="true">/</span> ' +
          refVal + (um.reference_unit || '');
        unitEl.hidden = false;
      } else {
        unitEl.innerHTML = '';
        unitEl.hidden = true;
      }
    }

    root.querySelectorAll('[data-qv-option]').forEach((group, gi) => {
      const label = group.querySelector('[data-qv-selected]');
      if (label) label.textContent = picks[gi] || '';
    });

    /* Variant → gallery sync. Jump to the slide carrying the variant's
       featured media id (if it has one). */
    const mediaId = (match.featured_media && match.featured_media.id)
                  || (match.featured_image && match.featured_image.id)
                  || null;
    if (mediaId != null) {
      const gal = root.querySelector('[data-qv-gallery]');
      const slideEl = gal && gal.querySelector('[data-qv-slide][data-media-id="' + mediaId + '"]');
      if (gal && slideEl && typeof gal._qvGo === 'function') {
        const idx = parseInt(slideEl.getAttribute('data-qv-slide'), 10);
        if (!isNaN(idx)) gal._qvGo(idx);
      }
    }
  };

  root.querySelectorAll('[data-qv-option-val]').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.qvOptionVal;
      const group = btn.closest('[data-qv-option]');
      if (!group) return;
      group.querySelectorAll('[data-qv-option-val="' + idx + '"]').forEach(b => {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      refreshVariant();
    });
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    if (atcBtn) atcBtn.disabled = true;
    if (atcLabel) atcLabel.textContent = STR('products', 'adding');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg = data.description || data.message || STR('products', 'addError');
        if (window.DostShowStockToast) window.DostShowStockToast(msg);
        if (atcBtn) atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = STR('products', 'addToCart');
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('dost:open-cart'));
      const modal = document.getElementById('quick-view-modal');
      if (modal) modal.classList.remove('quick-view-modal--open');
      document.body.style.overflow = '';
    } catch (err) {
      if (atcBtn) atcBtn.disabled = false;
      if (atcLabel) atcLabel.textContent = STR('products', 'addToCart');
    }
  });
};

class QuickView {
  constructor() {
    this.modal    = $('#quick-view-modal');
    if (!this.modal) return;

    this.inner    = $('.quick-view-modal__inner', this.modal);
    this.backdrop = $('.quick-view-modal__backdrop', this.modal);
    this.content  = $('[data-qv-content]', this.modal);
    this.loading  = $('[data-qv-loading]', this.modal);

    window.DostSwipeToClose(this.inner, () => this.close(), {
      handle: '[data-qv-drag-zone]'
    });

    document.addEventListener('click', async e => {
      const btn = e.target.closest('[data-quick-view]');
      if (btn) {
        e.preventDefault();
        await this.open(btn.dataset.quickView, btn.dataset.quickViewUrl);
      }
    });

    this.backdrop.addEventListener('click', () => this.close());
    this.modal.addEventListener('click', e => {
      if (e.target.closest('.quick-view-modal__close')) this.close();
    });
    document.addEventListener('keydown', e => e.key === 'Escape' &&
      this.modal.classList.contains('quick-view-modal--open') && this.close());
  }

  async open(handle, url) {
    this.modal.classList.add('quick-view-modal--open');
    lockScroll();
    if (this.loading) this.loading.hidden = false;
    if (this.content) { this.content.hidden = true; this.content.innerHTML = ''; }

    try {
      const sep = url.includes('?') ? '&' : '?';
      const r    = await fetch(`${url}${sep}view=quick-view`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const html = await r.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');
      const frag = doc.querySelector('[data-quick-view-content]');

      if (this.loading) this.loading.hidden = true;
      if (this.content) {
        if (frag) {
          this.content.innerHTML = frag.innerHTML;
        } else {
          this.content.innerHTML =
            '<div style="padding:48px;text-align:center;">' +
              '<p>' + STR('products', 'quickViewUnavailable') + '</p>' +
              '<a href="' + url + '" style="text-decoration:underline;">' + STR('products', 'viewFullDetails') + '</a>' +
            '</div>';
        }
        this.content.hidden = false;
        window.DostInitQuickView(this.content);
        trapFocus(this.content);
      }
    } catch {
      if (this.loading) this.loading.hidden = true;
      if (this.content) {
        this.content.innerHTML = '<div style="padding:48px;text-align:center;">' + STR('products', 'loadError') + '</div>';
        this.content.hidden = false;
      }
    }
  }

  close() {
    this.modal.classList.remove('quick-view-modal--open');
    unlockScroll();
  }
}

class ProductForm {
  constructor(el) {
    this.form = el;
    this.submitBtn = el.querySelector('[type=submit]');
    el.addEventListener('submit', e => this.handleATC(e));
  }

  async handleATC(e) {
    e.preventDefault();
    const id = this.form.querySelector('input[name="id"]')?.value;
    if (!id) { this.shakeBtn(this.submitBtn); return; }
    this.submitBtn.textContent = STR('products', 'adding');
    this.submitBtn.disabled = true;
    try {
      const fd  = new FormData(this.form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg = data.description || data.message || STR('products', 'addError');
        if (window.DostShowStockToast) window.DostShowStockToast(msg);
        this.submitBtn.textContent = STR('products', 'addToCart');
        this.submitBtn.disabled = false;
        this.shakeBtn(this.submitBtn);
        return;
      }
      bus.emit('cart:updated');
      bus.emit('cart:open');
      this.submitBtn.textContent = STR('products', 'added');
      setTimeout(() => {
        this.submitBtn.textContent = STR('products', 'addToCart');
        this.submitBtn.disabled = false;
      }, 1500);
    } catch {
      this.submitBtn.textContent = STR('products', 'addToCart');
      this.submitBtn.disabled = false;
    }
  }

  shakeBtn(btn) {
    btn.style.animation = 'shake 0.3s ease';
    btn.addEventListener('animationend', () => btn.style.animation = '', { once: true });
  }
}

class NewsletterForm {
  constructor(el) {
    el.addEventListener('submit', async e => {
      e.preventDefault();
      const input = el.querySelector('input[type=email]');
      const btn   = el.querySelector('[type=submit]');
      if (!input?.value) return;
      btn.textContent = '…';
      btn.disabled = true;

      try {
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('customer[email]', input.value);
        fd.append('customer[tags]', 'newsletter');
        await fetch('/', { method: 'POST', body: fd });
        el.innerHTML = '<p class="dost-label" style="color:var(--color-accent);">' + STR('newsletter', 'success') + '</p>';
      } catch {
        btn.textContent = STR('newsletter', 'submit');
        btn.disabled = false;
      }
    });
  }
}

class NewsletterPopup {
  constructor() {
    this.modal = $('#newsletter-popup');
    if (!this.modal || sessionStorage.getItem('dost-nl-dismissed')) return;

    const delay = parseInt(this.modal.dataset.delay || '45000');
    this.timer  = setTimeout(() => this.show(), delay);

    document.addEventListener('mouseleave', e => {
      if (e.clientY < 0 && !sessionStorage.getItem('dost-nl-dismissed')) this.show();
    }, { once: true });

    this.modal.querySelector('[data-popup-close]')?.addEventListener('click', () => this.dismiss());
    this.modal.querySelector('.quick-view-modal__backdrop')?.addEventListener('click', () => this.dismiss());
    document.addEventListener('keydown', e => e.key === 'Escape' && this.dismiss());
  }

  show() {
    if (sessionStorage.getItem('dost-nl-dismissed')) return;
    this.modal.classList.add('quick-view-modal--open');
  }

  dismiss() {
    sessionStorage.setItem('dost-nl-dismissed', '1');
    this.modal.classList.remove('quick-view-modal--open');
    clearTimeout(this.timer);
  }
}

class CartPage {
  constructor() {
    $$('[data-cart-qty-btn]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key   = btn.dataset.key;
        const delta = parseInt(btn.dataset.delta);
        const display = btn.parentElement.querySelector('.qty-stepper__val');
        const qty   = Math.max(0, parseInt(display.textContent) + delta);
        display.textContent = qty;
        await CartAPI.change(key, qty);
        window.location.reload();
      });
    });
  }
}

class LookbookHotspots {
  constructor() {
    $$('[data-hotspot]').forEach(spot => {
      const peek = $(`#peek-${spot.dataset.hotspot}`);
      if (!peek) return;
      spot.addEventListener('mouseenter', () => peek.classList.add('lookbook__product-peek--visible'));
      spot.addEventListener('mouseleave', () => peek.classList.remove('lookbook__product-peek--visible'));
    });
  }
}

class AnnouncementBar {
  constructor() {
    $$('.announcement-bar').forEach(bar => this.initBar(bar));
  }

  initBar(bar) {
    this.initMarquee(bar);
    this.initSlider(bar);
  }

  initMarquee(bar) {
    const marquee = bar.querySelector('[data-announcement-marquee]');
    if (!marquee) return;
    const track = marquee.querySelector('[data-announcement-marquee-track]');
    const group = track?.querySelector('[data-announcement-marquee-group]');
    if (!track || !group) return;

    const rate = parseFloat(bar.dataset.marqueeRate) || 80; // px / sec

    const layout = () => {
      // Reset to a single group, then duplicate as needed
      track.querySelectorAll('[data-announcement-marquee-group]').forEach((g, i) => { if (i > 0) g.remove(); });
      const firstGroup = track.querySelector('[data-announcement-marquee-group]');
      if (!firstGroup) return;

      const groupWidth = firstGroup.scrollWidth;
      if (groupWidth <= 0) return;
      const viewport = bar.clientWidth || marquee.clientWidth;
      // Need at least viewport + 1 full group of buffer for seamless loop
      const minTotal = viewport + groupWidth;
      let copies = 1;
      while (groupWidth * copies < minTotal) copies++;
      // Double for seamless wrap (animation translates by half of total)
      const totalCopies = copies * 2;
      for (let i = 1; i < totalCopies; i++) {
        track.appendChild(firstGroup.cloneNode(true));
      }
      const halfDistance = groupWidth * copies;
      const duration = halfDistance / rate;
      track.style.setProperty('--marquee-distance', `-${halfDistance}px`);
      track.style.animationDuration = duration + 's';
    };

    layout();
    const ro = new ResizeObserver(() => {
      clearTimeout(this._mqTimer);
      this._mqTimer = setTimeout(layout, 150);
    });
    ro.observe(bar);
  }

  initSlider(bar) {
    const slider = bar.querySelector('[data-announcement-slider]');
    if (!slider) return;

    const slides = [...slider.querySelectorAll('.announcement-bar__slide')];
    if (slides.length === 0) return;

    const autoplay = slider.dataset.autoplay === 'true';
    const speed    = parseInt(slider.dataset.speed) || 4000;

    let idx   = 0;
    let timer = null;

    const goTo = (n) => {
      slides[idx].classList.remove('announcement-bar__slide--active');
      idx = ((n % slides.length) + slides.length) % slides.length;
      slides[idx].classList.add('announcement-bar__slide--active');
    };

    const start = () => {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(() => goTo(idx + 1), speed);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    slider.querySelector('[data-announcement-next]')
      ?.addEventListener('click', () => { stop(); goTo(idx + 1); start(); });
    slider.querySelector('[data-announcement-prev]')
      ?.addEventListener('click', () => { stop(); goTo(idx - 1); start(); });

    if (autoplay && slides.length > 1) {
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
    }

    if (slides.length > 1) {
      let startX = 0;
      let startY = 0;
      let active = false;
      slider.addEventListener('touchstart', e => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        active = true;
        stop();
      }, { passive: true });
      slider.addEventListener('touchmove', e => {
        if (!active || e.touches.length !== 1) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && e.cancelable) e.preventDefault();
      }, { passive: false });
      slider.addEventListener('touchend', e => {
        if (!active) return;
        active = false;
        const dx = (e.changedTouches[0]?.clientX || startX) - startX;
        const dy = (e.changedTouches[0]?.clientY || startY) - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(idx + (dx < 0 ? 1 : -1));
        }
        start();
      });
      slider.addEventListener('touchcancel', () => { active = false; start(); });
    }

    start();
  }
}

class RecentlyViewed {
  static track(handle) {
    const viewed = JSON.parse(localStorage.getItem('dost-recently-viewed') || '[]');
    const next   = [handle, ...viewed.filter(h => h !== handle)].slice(0, 12);
    localStorage.setItem('dost-recently-viewed', JSON.stringify(next));
  }
}

document.addEventListener('shopify:section:load', e => {
  const root = e.target;
  if (!root) return;
  if (root.querySelector?.('.announcement-bar')) {
    new AnnouncementBar();
  }
  if (root.querySelector?.('[data-mega-trigger]') || root.querySelector?.('[data-mobile-menu-open]') || root.querySelector?.('.header')) {
    new MegaMenu();
    new MobileDrawer();
    new StickyHeader();
  }
  if (typeof window.DostInitProductCards === 'function') window.DostInitProductCards(root);
});

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
  new SearchOverlay();
  new MegaMenu();
  new MobileDrawer();
  new StickyHeader();
  new StickyPDPBar();
  new QuickView();
  new CartPage();
  new LookbookHotspots();
  new AnnouncementBar();
  new NewsletterPopup();

  $$('form[data-atc-form]').forEach(f => new ProductForm(f));

  $$('form[data-newsletter-form]').forEach(f => new NewsletterForm(f));

  const handle = document.body.dataset.productHandle;
  if (handle) RecentlyViewed.track(handle);

  $$('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      $$('.filter-pill').forEach(p => p.classList.remove('filter-pill--active'));
      pill.classList.add('filter-pill--active');
    });
  });

  $$('[data-footer-toggle]').forEach(btn => {
    const toggle = () => {
      const col = btn.closest('[data-footer-collapsible]');
      if (!col) return;
      const isOpen = col.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };
    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });
});

const shakeStyle = document.createElement('style');
shakeStyle.textContent = `@keyframes shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}`;
document.head.appendChild(shakeStyle);
